'use client';

import { useEffect } from 'react';

export default function HomeRedirect() {
  useEffect(() => {
    const language = localStorage.getItem('i18nextLng') || 'ar';
    window.location.replace(language);
  }, []);

  return null;
}
